var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 66,
    viewBox: "0 0 131 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.666 1C108.87 2.73299 107.582 44.2218 86.9994 49C70.0262 52.9402 61.4315 30.5738 44.3327 33C25.7864 35.6316 19.8515 58.9382 1.66602 65H129.666V1Z",
    fill: "#ECFDF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M129.666 1C108.87 2.73299 107.582 44.2218 86.9994 49C70.0262 52.9402 61.4315 30.5738 44.3327 33C25.7864 35.6316 19.8515 58.9382 1.66602 65H129.666V1Z",
    fill: "url(#paint0_linear_4568_60597)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 65C19.8515 58.9382 25.7864 35.6316 44.3327 33C61.4315 30.5738 70.0262 52.9402 86.9994 49C107.582 44.2218 108.87 2.73299 129.666 1",
    stroke: "#12B76A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4568_60597",
    x1: 65.666,
    y1: 1,
    x2: 65.666,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.641167,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/_Chart.63ad5c3b4ea88b162edb0bf65bdd796c.svg";
export { ForwardRef as ReactComponent };